import { render } from "./AppFooter.vue?vue&type=template&id=afa3c5a8&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "@/styles/components/app-footer.scss?vue&type=style&index=0&id=afa3c5a8&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afa3c5a8"]])

export default __exports__